import React, {
	Suspense,
	FC,
	useCallback,
	useContext,
	useState,
	useMemo,
	useRef,
	useEffect,
} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import classNames from 'classnames';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import { useFormik } from 'formik';
import Spinner from '../../../components/bootstrap/Spinner';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './CreateAccount.css';
import { useToasts } from 'react-toast-notifications';
import Toasts from '../../../components/bootstrap/Toasts';
// import Wizard, { WizardItem } from '../../../components/Wizard';
import { CountryDropdown } from 'react-country-region-selector';
import {
	createAccountArk,
	createAccountDemoArk,
	createAccountStep1,
	getUserByUsername,
	getCountry,
	createAccountLog,
	deposit,
} from '../../../apis';
import ConfigContext from '../../../contexts/configContext';
import { countries } from 'country-data';
import useDarkMode from '../../../hooks/useDarkMode';
import { VerifiedUser } from '../../../components/icon/material-icons';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';
import Icon from '../../../components/icon/Icon';
import { useParams } from 'react-router-dom';
import { decryptText } from '../../../helpers/helpers';
import useFacebookPixel from '../../../hooks/facebookPixelHook';

const RegisterCustom1 = React.lazy(
	() => import('../../../components/custom/register/custom1/RegisterCustom'),
);
const RegisterCustom2 = React.lazy(
	() => import('../../../components/custom/register/custom2/RegisterCustom'),
);

import { useLocation } from 'react-router-dom';
import countryList from 'react-select-country-list';
import Select from '../../../components/bootstrap/forms/Select';

interface LandingConfig {
	companyName: string;
	theme: {
		primaryColor: string;
		secondaryColor: string;
		textColor: string;
		inputBackground: string;
	};
}
function useQuery() {
	return new URLSearchParams(useLocation().search);
}

// ... import all your 10 components
const componentMap: Record<string, React.ComponentType<any>> = {
	Company1: RegisterCustom1,
	Company2: RegisterCustom2,
	// ... more
};

interface Props {
	companyName: string;
	[key: string]: any;
}

const DynamicRegister: React.FC<Props> = ({ companyName, ...props }) => {
	const SelectedComponent = componentMap[companyName] || <></>;

	return <SelectedComponent {...props} />;
};

const CreateAccount: FC = () => {
	const { darkModeStatus } = useDarkMode();
	const [PARENTID, setPARENTID] = useState<string | undefined>(undefined);
	const [tradingType, setTradingType] = useState<Number | undefined>(0);
	const [isDemo, setIsDemo] = useState<Boolean | undefined>(false);
	const [isLocked, setIsLocked] = useState<Boolean | undefined>(true);
	const [currenciesPolicyId, setCurrenciesPolicyId] = useState<Number | undefined>(0);
	const [genericPolicyId, setGenericPolicyId] = useState<Number | undefined>(0);
	const { parentId } = useParams();
	const location = useLocation();
	const query = useQuery();
	const referral = query.get('referral');
	const accountType = query.get('accountType') || 'real';

	const [isError, setIsError] = useState<boolean>(false);
	const [country, setCountry] = useState<string>('');
	const [countryCode, setCountryCode] = useState<string>('');
	const [referralFromStorage, setReferralFromStorage] = useState<string>('');

	const { addToast } = useToasts();
	const navigate = useNavigate();
	const handleLogIn = useCallback(
		(type?: string) => {
			if (process.env.REACT_APP_SUCCESS_REDIRECT_URL?.length && type === 'First') {
				window.open(process.env.REACT_APP_SUCCESS_REDIRECT_URL, '_blank');
			}
			navigate(type ? `/auth-pages/login?type=${type}` : `/auth-pages/login`);
		},
		[navigate],
	);
	const handleContinue = useCallback(
		(username: string) =>
			navigate('/auth-pages/create-account/step2', { state: { username: username } }),
		[navigate],
	);

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [otpVerifyModal, setOtpVerifyModal] = useState(false);
	const [otpResendBol, setOtpResendBol] = useState(true);
	const [landingConfig, setLandingConfig] = useState<LandingConfig | null>(null);

	const backgroundColor = darkModeStatus ? '#212529' : '#f8f9fa';
	const borderColor = darkModeStatus ? '#343a40' : '#f8f9fa';


	useEffect(() => {
		const fetchLandingConfig = async () => {
			try {
				const response = await fetch('/customLanding.json');
				if (!response.ok) {
					throw new Error('customLanding.json not found');
				}
				const data = await response.json();
				setLandingConfig(data);
			} catch (error) {
				console.warn('customLanding.json not found');
				setLandingConfig(null);
			}
		};

		fetchLandingConfig();
	}, []);
	useEffect(() => {
	const params = new URLSearchParams(location.search);
	const urlAccountType = params.get('accountType');

	if (
		process.env.REACT_APP_DISABLE_DEMO_CREATION_LOGIN === 'true' &&
		urlAccountType === 'demo'
	) {
		params.set('accountType', 'real');
		window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
	}
	}, [location.search]);
	useEffect(() => {
		if (parentId) {
			const decryptedText = decryptText(
				parentId,
				process.env.REACT_APP_SECRET_KEY || 'mlpoknijbbhuygvcftrdxeszawq',
			);
			if (decryptedText) {
				setPARENTID(decryptedText);
			}
		} else {
			setPARENTID(accountType == "real"?process.env.REACT_APP_PARENT_ID:process.env.REACT_APP_DEMO_PARENT_ID);
		}
		if (referral) {
			localStorage.setItem('referralCode', referral);
			setReferralFromStorage(referral);
		}
	}, [parentId, referral]);
	useEffect(() => {
		const storedReferral = localStorage.getItem('referralCode');
		if (storedReferral) {
			setReferralFromStorage(storedReferral);
		}
	}, []);

	useEffect(() => {
		const fetchCountryCode = async () => {
			try {
				const response = await getCountry();
				const detectedCountryCode =
					response?.country || response?.country_code || response?.countryCode;
				if (detectedCountryCode) {
					const normalizedCode = detectedCountryCode.toUpperCase();
					const country_code =
						process.env.REACT_APP_STATIC_COUNTRY_CODE || normalizedCode;
					setCountryCode(country_code);
					const detectedCountry = countries[country_code];
					if (detectedCountry?.name) {
						setCountry(detectedCountry.name);
					}
				}
			} catch (error) {
				console.warn('Unable to detect country automatically', error);
				setCountry('India');
				setCountryCode('IN');
			}
		};

		fetchCountryCode();
	}, []);

	const facebookPixelId = process.env.REACT_APP_FB_PIXEL_ID;
	const { trackEvent: trackFacebookPixelEvent } = useFacebookPixel(facebookPixelId);

	useEffect(() => {
		trackFacebookPixelEvent('PageView');
	}, [trackFacebookPixelEvent, location.pathname]);

	const handleKeyPress = (e: any) => {
		if (e.key === 'Enter') {
			formik.handleSubmit();
		}
	};
	// --- Env Logic ---
	const AccountTypesFromEnv = useMemo(() => {
		const raw =
			(process.env.REACT_APP_ACCOUNT_TYPES as string | undefined) ||
			(process.env as any).ACCOUNT_TYPES;
		if (!raw) return {} as Record<string, string>;
		try {
			return JSON.parse(raw) as Record<string, string>;
		} catch {
			return {};
		}
	}, []);

	const accountTypes = Object.keys(AccountTypesFromEnv);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			firstname: '',
			lastname: '',
			username: '',
			email: '',
			phoneNumber: '',
			accountType: '',
			deposit: '10000',
			countryResidence: countryCode,
			referralCode: referral || referralFromStorage || '',
			password: '',
			confirmPassword: '',
			language: 'RM Support Language',
		},
		validate: (values) => {
			const errors: {
				firstname?: string;
				lastname?: string;
				username?: string;
				email?: string;
				deposit?: string;
				accountType?: string;
				phoneNumber?: string;
				countryResidence?: string;
				referralCode?: string;
				password?: string;
				confirmPassword?: string;
				language?: string;
			} = {};

			if (!values.firstname) {
				errors.firstname = 'Required';
			}

			if (!values.username && !(process.env.REACT_APP_HIDE_USERNAME == "true")) {
				errors.username = 'Required';
			}
			if (!values.deposit) {
				errors.deposit = 'Required';
			}

			if (
				values.email !== '' &&
				!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
			) {
				errors.email = 'Invalid email address';
			}

			const cleanedPhone = (values.phoneNumber || '').replace(/[\s-]/g, '');
			const normalizedPhone = cleanedPhone.replace(/\D/g, '') || '';
			if (!normalizedPhone) {
				errors.phoneNumber = 'Phone number is required';
			} else if (!process.env.REACT_APP_STATIC_COUNTRY_CODE && normalizedPhone.length < 7) {
				errors.phoneNumber = 'Phone number must include at least 7 digits';
			} else if (!/^\+?\d+$/.test(cleanedPhone)) {
				errors.phoneNumber = 'Phone number must contain digits only';
			}

			if (!country) {
				errors.countryResidence = 'Required';
			}

			if (!values.password) {
				errors.password = 'Required';
			}

			if (!values.confirmPassword) {
				errors.confirmPassword = 'Required';
			}

			if (values.password !== values.confirmPassword) {
				errors.confirmPassword = "Passwords don't match";
			}
			if (accountType !== 'demo' && accountTypes.length > 0 && !values.accountType) {
				errors.accountType = 'Required';
			}
			if (
				process.env.REACT_APP_LANGUAGES?.length &&
				(!values.language || values.language == 'RM Support Language')
			) {
				errors.language = 'Required';
			}
			console.log('error', errors);
			return errors;
		},
		validateOnChange: false,
		onSubmit: async (values) => {
			setIsLoading(true);
			setIsError(false);
			const { city, state } = await fetch('https://ipapi.co/json/')
				.then((res) => res.json())
				.then((response) => {
					return { city: response.city, state: response.region };
				});
			// let mobile = values.phoneNumber;
			// const referral_temp = PARENTID !== undefined && !isNaN(Number(PARENTID)) && PARENTID;
			// mobile = referral_temp ? referral_temp : mobile;
			const formDataAccount = {
				firstName: values.firstname,
				userName: (process.env.REACT_APP_HIDE_USERNAME == "true")
					? values.phoneNumber
					: values.username,
				mobile: values.phoneNumber || values.username,
				country: country,
				deposit: accountType == 'demo' ? values.deposit : 0,
				countryResidence: values.countryResidence,
				password: values.password,
				parentId: parentId ? PARENTID : values.accountType?values.accountType:PARENTID,
				email: values.email.length ? values.email : null,
				telephonePass: `${city},${state}`,
				address: values.referralCode,
			};
			// console.log("formDataAccount==",formDataAccount)
			let _currenciesPolicyId = 0;
			let _genericPolicyId = 0;
			// retrive  city and state from user ip
			try {
				if (process.env.REACT_APP_HIDE_PERSONAL_DETAILS == 'false') {
					Object.assign(formDataAccount, { lastName: values.lastname });
				}
				if (process.env.REACT_APP_LANGUAGES?.split(',').length) {
					Object.assign(formDataAccount, { language: values.language });
				}
				// console.log('formDataAccount', formDataAccount, 'parentdi', PARENTID);
				let data = null;
				if (accountType == 'demo') {
					data = await createAccountDemoArk(
						formDataAccount,
						process.env.REACT_APP_ARKAPIURL,
					);
				} else {
					data = await createAccountArk(formDataAccount, process.env.REACT_APP_ARKAPIURL);
				}
				if (data.success === true) {
					trackFacebookPixelEvent('CompleteRegistration');
					setIsLoading(false);
						handleLogIn('First');
						addToast(
							<Toasts
								title='Success'
								icon='VerifiedUser'
								iconColor='warning'
								isDismiss>
								Created an account successfully.
							</Toasts>,
							{
								autoDismiss: true,
							},
						);
				} else {
					setIsLoading(false);
					addToast(
						<Toasts title='Failed' icon='Error' isDismiss>
							{data.message}
						</Toasts>,
						{
							autoDismiss: true,
						},
					);
				}
			} catch (err) {
				handleLogIn();
				setIsLoading(false);
				addToast(
					<Toasts title='Failed' icon='Error' isDismiss>
						{'failed to create account'}
					</Toasts>,
					{
						autoDismiss: true,
					},
				);
			}
			// }
		},
	});

	const disableCountrySelect =
		process.env.REACT_APP_STATIC_COUNTRY_CODE !== undefined &&
		process.env.REACT_APP_STATIC_COUNTRY_CODE !== '';
	return (
		<PageWrapper isProtected={false} title={'CreateAccount'} className={'bg-black'}>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					{process.env.REACT_APP_CUSTOM_LANDING_PAGE == undefined ||
					process.env.REACT_APP_CUSTOM_LANDING_PAGE === 'false' ? (
						<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
							<Card
								className='shadow-3d-dark'
								data-tour='login-page'
								style={{ backgroundColor: '#2a2d36' }}>
								<CardBody
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-l1-dark': darkModeStatus,
									})}>
									<div className='text-center my-5'>
										<Link
											to={`/auth-pages/create-account/step1${window.location.search}`}
											className={
												'text-decoration-none  fw-bold display-2 text-dark'
											}>
											<img src='/logo192.png' width={150} />
										</Link>
									</div>

									<div
										className={classNames(
											'text-center',
											'h4',
											'fw-bold',
											'mb-3',
											{
												'text-dark': !darkModeStatus,
												'text-white': darkModeStatus,
											},
										)}>
										{accountType == 'real'
											? 'Create A Live Account'
											: 'Create A Demo Account'}
									</div>

									<form className='row g-4'>
										{/* hide the steps for create live account 2,3 */}
										{/* {!process.env.REACT_APP_SKIP_FORM ? (
										<div className='col-md-12 mt-4'>
											<Wizard
												className='mb-0'
												isHeader='withButton'
												activeIndex={0}
												onSubmit={(e: Event) => {
													e.preventDefault();
												}}>
												<WizardItem id={`item-1`}>
												</WizardItem>
												<WizardItem id={`item-2`}>
												</WizardItem>
												<WizardItem id={`item-3`}>
												</WizardItem>
											</Wizard>
										</div>
										) : (
										<></>
									)} */}
										<div className='text-center h5 text-muted mt-3'>
											Personal Details
										</div>
										<div className='col'>
											<FormGroup id='firstname' isFloating label='Firstname'>
												<Input
													autoComplete='firstname'
													value={formik.values.firstname}
													isTouched={formik.touched.firstname}
													invalidFeedback={formik.errors.firstname}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onFocus={() => {
														formik.setErrors({});
													}}
												/>
											</FormGroup>
										</div>
										{process.env.REACT_APP_HIDE_PERSONAL_DETAILS == 'false' && (
											<div className='col-6'>
												<FormGroup
													id='lastname'
													isFloating
													label='Lastname'>
													<Input
														autoComplete='lastname'
														value={formik.values.lastname}
														isTouched={formik.touched.lastname}
														invalidFeedback={formik.errors.lastname}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
											</div>
										)}
										<div className='col-6'>
											<FormGroup
												id='phoneNumber'
												isFloating
												style={{ backgroundColor: 'transparent' }}>
												<PhoneInput
													country={countryCode.toLowerCase()}
													placeholder='Enter Mobile number'
													value={formik.values.phoneNumber}
													disableCountryCode={disableCountrySelect}
													disableCountryGuess={disableCountrySelect}
													disableDropdown={disableCountrySelect}
													onFocus={() => {
														formik.setErrors({});
													}}
													onChange={(value) =>
														formik.setFieldValue('phoneNumber', value)
													}
													inputStyle={{
														width: '100%',
														height: 'calc(3.5rem + 2px)',
														borderRadius: '1rem',
														border: '1px solid #f8f9fa',
														backgroundColor: backgroundColor,
														borderColor: borderColor,
													}}
												/>
												<Input
													type='hidden'
													autoComplete='phoneNumber'
													value={formik.values.phoneNumber}
													isTouched={formik.touched.phoneNumber}
													invalidFeedback={formik.errors.phoneNumber}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onFocus={() => {
														formik.setErrors({});
													}}
												/>
											</FormGroup>
										</div>
										<div className='col-6'>
											<FormGroup id='password' isFloating label='Password'>
												<Input
													type='password'
													autoComplete='current-password'
													value={formik.values.password}
													isTouched={formik.touched.password}
													invalidFeedback={formik.errors.password}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
												/>
											</FormGroup>
										</div>
										<div className='col-6'>
											<FormGroup
												id='confirmPassword'
												isFloating
												label='Confirm Password'>
												<Input
													type='password'
													autoComplete='confirm-password'
													value={formik.values.confirmPassword}
													isTouched={formik.touched.confirmPassword}
													invalidFeedback={formik.errors.confirmPassword}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onKeyDown={handleKeyPress}
												/>
											</FormGroup>
										</div>
										{process.env.REACT_APP_LANGUAGES?.length && (
											<div className='col-6'>
												<FormGroup
													id='language'
													isFloating
													label={'RM Support Language'}>
													<select
														className={classNames(
															'form-select',
															'form-select-sm',
															'mb-3',
															{
																'is-invalid':
																	formik.errors.language,
															},
														)}
														id='language'
														name='language'
														value={formik.values.language}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}>
														{process.env.REACT_APP_LANGUAGES?.split(
															',',
														).map((item, index) => {
															return (
																<option key={index} value={item}>
																	{item}
																</option>
															);
														})}
													</select>
												</FormGroup>
											</div>
										)}
										{!(process.env.REACT_APP_HIDE_USERNAME == "true") && (
											<div className='col-6'>
												<FormGroup
													id='username'
													isFloating
													label='Username'>
													<Input
														autoComplete='username'
														value={formik.values.username}
														isTouched={formik.touched.username}
														invalidFeedback={formik.errors.username}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
											</div>
										)}
										{process.env.REACT_APP_HIDE_PERSONAL_DETAILS ===
											'false' && (
											<div className='col-6'>
												<FormGroup id='email' isFloating label='Your email'>
													<Input
														type='email'
														autoComplete='email'
														value={formik.values.email}
														isTouched={formik.touched.email}
														invalidFeedback={formik.errors.email}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
											</div>
										)}
										{/* accountTypes */}
										{accountType !== 'demo' && accountTypes.length > 0 && (
											<div className='col-6'>
												<FormGroup
													id='accountType'
													isFloating
													label='Account Type'>
													<select
														className={classNames(
															'form-select',
															'form-select-sm',
															'mb-3',
															{
																'is-invalid':
																	formik.errors.accountType,
															},
														)}
														id='accountType'
														name='accountType'
														value={formik.values.accountType}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onKeyDown={handleKeyPress}
														onFocus={() => {
															formik.setErrors({});
														}}>
														<option defaultChecked value=''>
															Select Account Type
														</option>
														{accountTypes.map((account: string) => {
															return (
																<option
																	value={
																		AccountTypesFromEnv[account]
																	}>
																	{account}
																</option>
															);
														})}
													</select>
												</FormGroup>
											</div>
										)}
										{accountType == 'demo' && (
											<div className='col-6'>
												<FormGroup id='deposit' isFloating label='Deposit'>
													<select
														className={classNames(
															'form-select',
															'form-select-sm',
															'mb-3',
															{
																'is-invalid': formik.errors.deposit,
															},
														)}
														id='deposit'
														name='deposit'
														value={formik.values.deposit}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}>
														<option value={10000}>10000</option>
														<option value={50000}>50000</option>
														<option value={100000}>100000</option>
														<option value={1000000}>1000000</option>
													</select>
												</FormGroup>
											</div>
										)}
										<div className='col-12'>
											<FormGroup
												id='referralCode'
												isFloating
												label='Referral Code (if you have one)'>
												<Input
													autoComplete='referralCode'
													value={formik.values.referralCode}
													isTouched={formik.touched.referralCode}
													invalidFeedback={formik.errors.referralCode}
													isValid={formik.isValid}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													onFocus={() => {
														formik.setErrors({});
													}}
												/>
											</FormGroup>
										</div>

										<div className='col-12'>
											
												<Button
													color='info'
													className='w-100 py-3'
													onClick={formik.handleSubmit}>
													{isLoading && (
														<Spinner isSmall inButton isGrow />
													)}
													Create Account
												</Button>
										</div>
									</form>
								</CardBody>
							</Card>

							<div className='text-center mb-5'>
								<span style={{ color: 'white' }}>
									Already have an account? &#8196;
								</span>
								<span
									style={{ color: 'skyblue', cursor: 'pointer' }}
									className='rounded-1 w-100'
									onClick={() => {
										handleLogIn();
									}}>
									Log in
								</span>
							</div>
						</div>
					) : (
						landingConfig != null && (
							<DynamicRegister
								companyName={landingConfig?.companyName || ''}
								formik={formik}
								handleLogIn={handleLogIn}
								handleKeyPress={handleKeyPress}
								countryCode={countryCode}
								darkModeStatus={darkModeStatus}
								isLoading={isLoading}
								disableCountrySelect={disableCountrySelect}
							/>
						)
					)}
				</div>
			</Page>
		</PageWrapper>
	);
};

export default CreateAccount;
